var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"tranEase",attrs:{"id":"goTop"},on:{"click":_vm.goTop}},[_c('div',{staticClass:"mx-2 font1.5"},[_c('i',{staticClass:"fas fa-arrow-up"})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }